'use strict';

import {combineReducers} from "redux";
import SupportReducer from "./Reducers/SupportReducer";
import ClientReducer from "../../Entities/Client/ClientReducer";

export default combineReducers({
    'main': SupportReducer,
    'client': ClientReducer
});